import { ReactSelectInstanceRefObject } from '../../custom-react-select.types';
import Text from '@ui/text/text/text';
import EditTextWrapper from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/edit-text-wrapper';

type Props = {
  showHeader: boolean;
  selectRef: ReactSelectInstanceRefObject;
  disabled?: boolean;
  label?: string;
};

const TruncatedCreatableMultiReactSelectHeader = ({ showHeader, selectRef, disabled, label }: Props) => {
  const handleHeaderClick = () => {
    if (selectRef?.current && !disabled) {
      const select = selectRef.current;
      select?.focus();
    }
  };

  if (!showHeader) return null;
  return (
    // note: intentional onClick on a div - we don't want this to be tabbable because the select component itself is tabbable
    <div onClick={handleHeaderClick} className="flex fd-row jc-space-between">
      <Text className="L3 height-24 padding-l-4 flex ai-center" color="var(--gray-300)">
        {label}
      </Text>

      <div className="truncated-creatable-multi-react-select__edit-text-wrapper">
        <EditTextWrapper />
      </div>
    </div>
  );
};

export default TruncatedCreatableMultiReactSelectHeader;
